import React from 'react';
import clsx from 'clsx';

export type ButtonVariant = 'primary' | 'secondary' | 'danger' | 'ghost';
export type ButtonSize = 'sm' | 'md';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  /** ラベル左に表示するアイコン（任意）。 */
  leftIcon?: React.ReactNode;
}

const base =
  'inline-flex items-center justify-center gap-1.5 rounded-lg font-semibold transition-all ' +
  'active:scale-[0.97] focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-1 ' +
  'disabled:opacity-50 disabled:pointer-events-none whitespace-nowrap';

const sizeClasses: Record<ButtonSize, string> = {
  sm: 'h-8 px-3 text-xs',
  md: 'h-10 px-4 text-sm',
};

const variantClasses: Record<ButtonVariant, string> = {
  primary:
    'text-white bg-gradient-to-b from-blue-500 to-blue-600 shadow-sm ' +
    'hover:from-blue-600 hover:to-blue-700 hover:shadow-md focus-visible:ring-blue-400',
  secondary:
    'text-gray-700 bg-white border border-gray-300 shadow-sm ' +
    'hover:bg-gray-50 hover:shadow focus-visible:ring-gray-300',
  danger:
    'text-white bg-gradient-to-b from-red-500 to-red-600 shadow-sm ' +
    'hover:from-red-600 hover:to-red-700 hover:shadow-md focus-visible:ring-red-400',
  ghost:
    'text-blue-600 hover:bg-blue-50 focus-visible:ring-blue-300',
};

/** システム共通のボタン。デザイントーン（グラデ・影・押下アニメ）を一元管理する。 */
export function Button({
  variant = 'primary',
  size = 'md',
  leftIcon,
  className,
  type = 'button',
  children,
  ...rest
}: ButtonProps) {
  return (
    <button
      type={type}
      className={clsx(base, sizeClasses[size], variantClasses[variant], className)}
      {...rest}
    >
      {leftIcon}
      {children}
    </button>
  );
}
